export const raw = {
	subjects: {
		'bonus': {
			name: 'Hydrazine',
			color: 'red',
			tasks: {
				'swing': {
					name: 'Swing Test',
					desc: 'Conduct a swing test',
					hydrazine: 2,
					fullDesc: 'Swing a rocket around your head on a piece of string in order to test its stability.',
					rules: {
						pass: [
							'Swing test must be performed competently and safely',
							'Rocket must self-correct after being initially swung facing backwards'
						],
						options: [
							'Swing tests often take multiple goes to get right, this is acceptable',
							'Spin around with the rocket (don\'t get dizzy and fall) or stand still and just spin the string around your head'
						],
						fail: [
							'Rocket swings unstable'
						]
					},
					outcomes: [
						'How to conduct an aerodynamic test of their rocket, proving their rocket\'s construction produces a stable flight. This should be in line with theoretical simulations or manufacturers instructions.',
						'How take-off speed affects static stability and the importance of correct motor selection in order to produce the necessary take-off speed'
					],
					help: [
						'A swing test is where you tie a line to your rocket aroung its CG and spin it around your head to check that it flies stable.',
						'Start swinging with the rocket facing backwards, it should self-correct from this orientation and face forwards.',
						'blog:swing-tests',						
						'https://www.youtube.com/embed/3S7_fg6ZCF4?si=uSC_f2pDIebJwVk3'
					]
				},
				'diy-wadding': {
					name: 'DIY Wadding',
					desc: 'Produce your own fireproof wadding',
					hydrazine: 10,
					fullDesc: 'Create and fly your own fireproof wadding',
					rules: {
						pass: [
							'The wadding must be proven to be fireproof before flight',
							'The wadding must be disposable and environmentally friendly'
						],
						options: [
							'Any fireproof or fire-proofable material may be used'
						],
						fail: [
							'The wadding fails a ground test by burning/smoldering',
							'The spent wadding would be considered littering or harmful to the environment',
							'The wadding is not disposable, e.g. a Nomex blanket',
							'Lettuce or similar is not allowed. Usually we would fully endorse such an evironmentally friendly option however this task is about making wadding'
						]
					},
					outcomes: [
						
					],
					help: [
						'Soaking tissue in a saturated boric acid (Borax) solution is a cheap and effective recipe. Obey COSHH and H&S best practices.',
						'https://www.rocketryforum.com/threads/homemade-recovery-wadding.153417/'
					]
				},
				'diy-simple-chute': {
					name: 'DIY Parachute',
					desc: 'Build and fly a simple home-made parachute',
					hydrazine: 5,
					fullDesc: 'Construct and fly a home-made parachute from plastic sheet or ripstop nylon fabric.',
					rules: {
						pass: [
							'The parachute must have multiple shroud lines securely attached to it',
							'The parachute must be made from plastic sheet or ripstop nylon fabric. If nylon then it does not need to be sewn from segments, it can be a single piece',
							'The parachute must be made from non-flammable material',
							'The parachute must be flown, deploy properly and recover the rocket safely',
							'The parachute must be substantially intact after landing - minor damage from the ejection charge is permitted'
						],
						options: [
							'The parachute may be circular or any regular 5+ pointed polygon shape',
							'The parachute may contain a spill hole',
							'Construct the parachute using non-flammable plastic sheet or ripstop nylon fabric'
						],
						fail: [
							'Shroud lines are broken or detached',
							'Parachute does not deploy properly, or gets tangled',
							'Parachute burns or poses a fire hazard',
							'The parachute is substantially damaged after flying - small burns from the ejection charge are permitted',
						]
					},
					outcomes: [
						"How to build a simple parachute",
						'An understanding of drag and how the weight of a rocket relates to the required parachute size and design',
						'The importance of construction methodologies and testing to produce a durable parachute capable of withstanding repeated flights'
					],
					help: [
						'The Tools section of the UKRA Members Portal includes a parachute size and shapre calulator which you can use to determine an appropriate parachute for your rocket',
						'blog:parachutes',
						'https://www.apogeerockets.com/Advanced_Construction_videos/Rocketry_Video_469',
						'https://www.youtube.com/embed/ROp6lli57fM?si=4-OYdo0sSusSFl8X',
						'https://www.youtube.com/embed/haPqfV4kHTM?si=QKKk88QL2tEtqtqV',
						'https://www.youtube.com/embed/N5l_SST5t8M?si=sTeJnIa7jYk_N4mO',
						'https://www.youtube.com/embed/ux2VpTMN6pU?si=OWjqc2nnOocm05Uh'
					]
				},
				'baffle': {
					name: 'Baffle',
					desc: 'Build and fly a rocket with a baffle',
					hydrazine: 5,
					rules: {
						pass: [
							'Baffle must successfully stop hot gasses from damaging the parachute/streamer'
						],
						options: [
							'Baffle may be retrofitted to an existing rocket or built into a new rocket'
						],
						fail: [
							'Parachute/streamer has non-trivial damage',
							'Wadding is used in addition to the baffle'
						]
					},
					outcomes: [
						'An understanding of how black-powder explosive charges behave',
						'Why it is important to impede hot gases and sparks from an ejection charge',
						'What is required to reduce the effects of hot-gass ejection charges in order to protect recovery hardware',
						'Different baffle construction techniques, and how to anchor recovery hardware'
					]
				},
				'sim': {
					name: 'Simulation',
					desc: 'Simulate a rocket and flight',
					hydrazine: 5,
					rules: {
						pass: [
							'Must be an accurate simulation of dimensions and masses',
							'Flyer must be able to explain the flight profile in reasonable detail showing their understanding of what the simulation is showing',
							'The rocket being simulated must fly successfully'
						],
						options: [
							'You may use any off-the-shelf simulation software such as OpenRocket or RockSim',
						],
						fail: [

						]
					},
					outcomes: [
						'How to use simulation software to model a rocket and its flight',
						'The importance of accurate measurement taking',
						'Experience in experimenting with different design parameters and motor thrust-curve choice and how these affect flight profiles'
					],
					help: [
						'https://www.apogeerockets.com/Rocksim',
						'https://openrocket.info/',
						'https://www.youtube.com/embed/lib90QZ8lG8?si=oIHCe-hNnz3vFIQf',
						'https://www.youtube.com/embed/TBk8CBJf2K0?si=XHeGseZ3Ij7hm33a',
						'https://www.youtube.com/embed/kXs2w24Tkds?si=eqp34Fyo81WI3sAw',
						'https://www.youtube.com/embed/PlRaCN1xiwg?si=1-CzbCInMnN22PzD'
					]
				},
				'drag-race': {
					name: 'Drag Race',
					desc: 'Challenge another rocketeer',
					fullDesc: 'Launch your rocket at the same time as another person\'s in order to "race".',
					hydrazine: 5,
					rules: {
						pass: [
							'Launch your rocket at the same time as at least one other person',
							'All drag-racers must be MAP participants'
						],
						options: [
							'The rockets can be different models/designs and fly on different motors',
							'Race one or many other flyers',
							'You do not need to "win" in any sense, just participate'
						],
						fail: [
							'Your rocket does not launch',
							'Your rocket collides with another rocket'
						]
					},
					outcomes: [
						'Cameraderie and team-work'
					]
				},
				'papering': {
					name: 'Fin Papering',
					desc: 'Laminate fins for strength',
					fullDesc: 'Apply a layer of paper over the surface of your fins to add strength and produce a finer surface finish.',
					hydrazine: 15,
					rules: {
						pass: [
							'Papering must be well applied to all the fins',
							'Flyer must be able to explain what materials they used and what process they followed'
						],
						options: [
							'You may use any sort of paper',
							'Fins may be balsa or ply'
						],
						fail: [
							'Papering is not well applied, e.g. large creases, uneven surface, raised fibres, poor coverage'
						]
					},
					outcomes: [
						'Understanding of the benefits of lamination in terms of strength and surface aesthetic',
						'Appreciation of the properties of balsa/ply and how lamination can compliment these'
					],
					help: [
						'https://www.youtube.com/embed/JnYBSbYr8ZE?si=f-QnR9o5aICXYwKc'
					]
				},
				'record': {
					name: 'Altitude Record',
					desc: 'Attempt an altitude record',
					special: '& +50 XP',
					specialFull: 'Setting a new altitude record will earn you 50 XP, coming within 15% will earn you 10 XP. Submit your record attempt through the Flight Log tool.',
					hydrazine: 25,
					rules: {
						pass: [
							'Make a serious attempt to break the record',
							'Reach at least 15% lower than the current record',
							'Record attempt must be approved by UKRA via Members Portal submission',
							'You must follow the rules of altitude record attmepts: https://ukra.org.uk/info/records/'
						],
						options: [
							'You may attempt any record class within your allowed Certification level'
						],
						fail: [
							'The rocket does not reach at least 15% lower than the current record'
						]
					},
					outcomes: [
						'Understanding of the importance of aerodynamic, thrust-to-weight and thrust-curve optimisation to achieve maximum altitude',
						'Appreciation for construction material choices and how often you need to choose between strength and weight, and how you may optimise this balance'
					]
				},
				'canard': {
					name: 'Canard fins',
					desc: 'Build a rocket with canard fins',
					hydrazine: 15,
					rules: {
						pass: [
							'At least 2 aerodynamically significant canard fins must be mounted less than 33% rocket length from the nose',
							'Aerodynamic significance of the canard fins must be account for and still produce a stable flight'
						],
						options: [
							'You may have 2 or more individual canard fins',
							'A simulation is recommended and may be required at the discretion of the MAP Advisor and/or RSO'
						],
						fail: [
							'Forward fins are trivially sized with respect to the rest of the rocket',
							'Canard fins produce (or are likely to produce) an unstable flight'
						]
					},
					outcomes: [
						'Deeper appreciation for aerodynamic effects and how the center-of-pressure is calculated/manifests itself',
						'Deeper understanding of the importance of static stability margin and appropriate weight distribution'
					]
				},
				'aerotech': {
					name: 'RMS - Aerotech',
					desc: 'Assemble and fly an Aerotech RMS motor',
					fullDesc: 'Assemble and fly any Aerotech RMS motor.',
					hydrazine: 20,
					rules: {
						pass: [
							'Must be a reloadable "RMS" motor',
							'You must be supervised by the vendor or other experienced flyer if this is your first time or if you are otherwise unsure'
						],
						options: [
							'Can be any impulse, diameter or length motor',
							'You do not need to own the casing/closures, you may rent or borrow them',
						],
						fail: [
							'A single-use "DMS" motor is used',
							'Motor is not an Aerotech "RMS"',
							'Motor or ejection fails due to improper assembly',
							'Ejection occurs well before or after apogee'
						]
					},
					outcomes: [
						'Experience in assembling an Aerotech motor',
						'The importance of following instructions to the letter',
						'The importance of taking your time to get things right'
					]
				},
				'cti': {
					name: 'RMS - Cesaroni',
					desc: 'Assemble and fly a Cesaroni motor',
					fullDesc: 'Assemble and fly a Cesaroni reloadable motor. You should be supervised by the vendor or other experienced flyer if this is your first time or if you are otherwise unsure.',
					hydrazine: 15,
					rules: {
						pass: [
						],
						options: [
							'Can be any impulse, diameter or length motor',
							'You do not need to own the casing/closures, you may rent or borrow them',
						],
						fail: [
							'Motor or ejection fails due to improper assembly',
							'Ejection occurs well before or after apogee'
						]
					},
					outcomes: [
						'Experience in assembling a Cesaroni motor'
					]
				},
				'3dprinting': {
					name: '3D Printed Components',
					desc: '3D print components for a rocket',
					fullDesc: 'Design and 3D print non-trivial component(s) for a rocket.',
					hydrazine: 15,
					rules: {
						pass: [
							'Component(s) must be non-trivial in size and function. Nose cones, fin cans, electronics sleds all qualify',
							'Component(s) must be designed and integrated into the rocket by the flyer. MAP Assessor should quiz the flyer on software used and approach taken',
							'Components(s) must pass inspection by the RSO and be judged to be robust enough for the expected forces they will be subjected to'
						],
						options: [
							'The componment(s) may be printed by a 3rd party',
							'Any non-trivially sized and functionally important part of the rocket may be 3D printed'
						],
						fail: [
							'Component(s) are trivial in size or function, small farings or rail guides do not qualify',
							'Component(s) are clearly not designed to be strong enough',
							'Components have not been well printed with respect to structural integrity under load/heating',
							'Component(s) break or fail - slight delamination is permitted if easily repairable in-the-field'
						]
					},
					outcomes: [
						'Exerpience in 3D modelling',
						'Experience in manufacturing complexities',
						'Experience in forces and material stresses'
					]
				},
				'spin-stabilised': {
					name: 'Spin Stabilised',
					desc: 'Build and fly a spin-stabilised rocket',
					hydrazine: 15,
					rules: {
						pass: [
							'Rocket must be designed to spin and not just do so because of construction quirks',
							'Must spin due to a static design and not have any active control surfaces or mechanisms'
						],
						options: [
							'You may cause the rocket to spin using any suitable aerodynamic surface - e.g. canted fins',
						],
						fail: [
							'Rocket is a whirly-bird or monocopter type design - it must be a "normal" shaped rocket'
						]
					},
					outcomes: [
						'Appreciation for gyroscopic effects and how they can lead to stabilisation',
						'The importance of accurate and high-quality rocket construction to achieve/prevent spin'
					]
				},
				'piston-ejection': {
					name: 'Piston Ejection',
					desc: 'Use a piston to eject your recovery device',
					hydrazine: 15,
					rules: {
						pass: [
							'The recovery device must be deployed properly'
						],
						options: [
							'Can be a new or existing rocket with a piston-ejection mechanism retro-fitted.'
						],
						fail: [
							'Ejection mechanism does not operate properly',
							'Recovery system detaches or is substantially damaged such that a repeat flight is not possible without non-trivial repairs'
						]
					},
					outcomes: [
						'Appreciation for alternative ejection mechanisms and parachute protection',
						'Experience building to tight tolerances and high-quality design'
					]
				},
				'fibreglass': {
					name: 'Fibreglass',
					desc: 'Use fibreglass to reinforce fins or body tubes',
					fullDesc: 'Apply firbeglass to significant structural components of your rocket to reinforce them.',
					hydrazine: 30,
					rules: {
						pass: [
							'Structurally significant components must be laminated in or home-made from fibreglass, e.g. body tube or fins',
							'The MAP Assessor will quiz you on your methodology to understand the process you followed and what you have learned'
						],
						options: [
							'Use one or more layers of fibreglass',
							'Use any weight or weave of fibreglass'
						],
						fail: [
							'The fibreglass parts are preformed or not made by you - such parts are allowed in addition to self-applied fiberglass parts',
							'Only trivial parts or a very small area (with respect to the size of the rocket) is reinforced with fibreglass',
							'The firebglass seriously delaminates from itself or the substrate',
							'The fibreglass breaks or cracks',
							'The fibreglass is not well applied - this is not a fibreglassing test per se, but serious creases, lumps, fraying or a very uneven surface will fail'
						]
					},
					outcomes: [
						'Experience using fibreglass and lamination resins',
						'Appreciation for COSHH and safe manufacturing processes',
						'Appreciation for the importance of tooling in the manufactuing process'
					]
				},
				'carbonfibre': {
					name: 'Carbon Fibre',
					desc: 'Use carbon fibre to reinforce fins or body tubes',
					fullDesc: 'Apply carbon fibre to significant structural components of your rocket to reinforce them.',
					hydrazine: 30,
					rules: {
						pass: [
							'Structurally significant components must be laminated in or home-made from carbon fibre, e.g. body tube or fins',
							'The MAP Assessor will quiz you on your methodology to understand the process you followed and what you have learned'
						],
						options: [
							'Use one or more layers of carbon fibre',
							'Use any weight or weave of carbon fibre'
						],
						fail: [
							'The carbon fibre parts are preformed or not made by you - such parts are allowed in addition to self-applied carbon fibre parts',
							'Only trivial parts or a very small area (with respect to the size of the rocket) is reinforced with carbon fibre',
							'The carbon fibre seriously delaminates from itself or the substrate',
							'The carbon fibre breaks or cracks',
							'The carbon fibre is not well applied - this is not a carbon fibre application test per se, but serious creases, lumps, fraying or a very uneven surface will fail'
						]
					},
					outcomes: [
						'Experience using carbon fibre and lamination resins',
						'Appreciation for COSHH and safe manufacturing processes',
						'Appreciation for the importance of tooling in the manufactuing process'
					]
				}
			}
		},
		'propulsion': { 
			name: 'Propulsion',
			color: 'yellow',
			tasks: {
				'A/4': {
					name: '1/4 A Motor',
					desc: 'Fly a rocket on a 1/4 A motor',
					xp: 1,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one 1/4 A motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight',
							'May be a black-powder or composite motor'
						],
						fail: [
							'You do not use at least one 1/4 A motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on 13mm, low-thrust motors'
					]
				},
				'A/2': {
					name: '1/2 A Motor',
					desc: 'Fly a rocket on a 1/2 A motor',
					xp: 2,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one 1/2 A motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight',
							'May be a black-powder or composite motor'
						],
						fail: [
							'You do not use at least one 1/2 A motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on 13mm, low-thrust motors'	
					]
				},
				'A': {
					name: 'A Motor',
					desc: 'Fly a rocket on an A motor',
					xp: 3,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one A motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight',
							'May be a black-powder or composite motor'
						],
						fail: [
							'You do not use at least one A motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on low-thrust, A motors'
					]
				},
				'B': {
					name: 'B Motor',
					desc: 'Fly a rocket on a B motor',
					xp: 5,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one B motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight',
							'May be a black-powder or composite motor'
						],
						fail: [
							'You do not use at least one B motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on B motors'
					]
				},
				'C': {
					name: 'C Motor',
					desc: 'Fly a rocket on a C motor',
					xp: 5,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one C motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight',
							'May be a black-powder or composite motor'
						],
						fail: [
							'You do not use at least one C motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on C motors'
					]
				},
				'D': {
					name: 'D Motor',
					desc: 'Fly a rocket on a D motor',
					xp: 5,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one D motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight',
							'May be a black-powder or composite motor'
						],
						fail: [
							'You do not use at least one D motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on D motors'
					]
				},
				'E': {
					name: 'E Motor',
					desc: 'Fly a rocket on a E motor',
					special: '& L1 Qualification',
					specialFull: 'Completing this task qualifies you for Level 1 High Power Certification',
					xp: 10,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one E motor',
							'Must be a composite (non-black-powder) motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight'
						],
						fail: [
							'You do not use at least one E motor',
							'You use a legacy, non-CE/UKCA marked, illegal Estes E motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on E motors'
					]
				},
				'F': {
					name: 'F Motor',
					desc: 'Fly a rocket on a F motor',
					xp: 15,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one F motor',
							'Must be a composite (non-black-powder) motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight'
						],
						fail: [
							'You do not use at least one F motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on F motors'
					]
				},
				'G': {
					name: 'G Motor',
					desc: 'Fly a rocket on a G motor',
					xp: 35,
					rules: {
						pass: [
							'Successfully fly and recover a rocket flown with at least one G motor',
							'Must be a composite (non-black-powder) motor'
						],
						options: [
							'May be a single motor, part of a cluster or staged flight'
						],
						fail: [
							'You do not use at least one G motor'
						]
					},
					outcomes: [
						'Experience building rockets capable of flying on G motors'
					]
				},
				'micro-hybrid': {
					name: 'Micro-hybrid',
					desc: 'Fly a rocket on a micro-hybrid motor',
					xp: 100,
					rules: {
						pass: [
							"Requires Safety and Technical comittee oversight - contact UKRA"
					  	]
          			},
					outcomes: [
						'Experience building/assembling simple hybrid motors',
						'Awareness of the different fuel types possible with hybrid motors',
						'Appreciation for the difficulty in starting a hybrid motor, and the design considerations that can ease this',
						'Appreciation of the thrust-to-weight difference between hybrid and solid fuel motors'
					]
				},
				'clustercomp18': {
					name: 'Small Cluster',
					desc: 'Fly a rocket on a cluster of <=18mm composite motors',
					xp: 25,
					rules: {
						pass: [
							'All motors must be <= 18mm',
							'All motors must not be black-powder based',
							'Cluster and ignition method must be inspected by the RSO prior to launch',
							'All motors must ignite properly',
							'The combined thrust from all motors must be within that allowed by your Certification level'
						],
						options: [
							'Use 2 or more motors',
							'Use 13mm or 18mm motors, or a mix',
							'Use any thrust class of motor, including a mix'
						],
						fail: [
							'One or more motors do not ignite',
							'Any motors are BP',
							'Flight is unstable/unsafe'
						]
					},
					outcomes: [
						'Experience building cluster rockets',
						'Experience igniting composite clusters'
					],
					help: [
						'blog:clustering',
						'https://www.youtube.com/embed/BGuJnXVa3rg?si=_cUAQElLPlXePxcH',
						'https://www.youtube.com/embed/vTJ-CY7_7HU?si=GcfgbUcN9U_yHc5p'
					]
				},
				'clustercomp24': {
					name: 'Large Cluster',
					desc: 'Fly a rocket on a cluster of >= 24mm composite motors',
					xp: 30,
					rules: {
						pass: [
							'All motors must be 24mm or larger',
							'All motors must not be black-powder based',
							'Cluster and ignition method must be inspected by the RSO prior to launch',
							'All motors must ignite properly',
							'The combined thrust from all motors must be within that allowed by your Certification level'
						],
						options: [
							'Use 2 or more motors',
							'Use all 24mm motors, or a mix of sizes - all motors must be at least 24mm',
							'Use any thrust class of motor, including a mix'
						],
						fail: [
							'One or more motors do not ignite',
							'Any motors are BP',
							'Flight is unstable/unsafe'
						]
					},
					help: [
						'blog:clustering',
						'https://www.youtube.com/embed/BGuJnXVa3rg?si=_cUAQElLPlXePxcH',
						'https://www.youtube.com/embed/vTJ-CY7_7HU?si=GcfgbUcN9U_yHc5p'
					]
				}
			}
		},
		'construction': {
			name: 'Construction',
			color: 'blue',
			tasks: {
				'rtf': {
					name: 'RTF',
					desc: 'Fly a Ready-To-Fly rocket',
					xp: 2,
					fullDesc: 'Fly and recover a prefabricated (ready-to-fly) rocket',
					rules: {
						pass: [
							'Must be a rocket you haven\'t used before in MAP'
						],
						options: [
							'May be an off-the-shelf RTF rocket or an existing rocket built by someone else'
						],
						fail: [

						]
					}
				},
				'assembly': {
					name: 'Assembly-Only',
					desc: 'Build and fly an assembly-only rocket kit',
					xp: 3,
					fullDesc: 'Build and fly a prefabricated (simple assembly required) rocket kit',
					rules: {
						pass: [
							'Must be a rocket you haven\'t used before in MAP'
						],
						options: [
							
						],
						fail: [

						]
					}
				},
				'kit': {
					name: 'Kit',
					desc: 'Build and fly a rocket kit',
					xp: 3,
					rules: {
						pass: [
							'You must build the rocket, it cannot be pre-built'
						],
						options: [
							'Any commercially available kit can be used, out-of-production kits are allowed'
						],
						fail: [
							'The rocket is a simple, Assembly-Only kit'
						]
					},
				},
				'cone': {
					name: 'Cone',
					desc: 'Build and fly a cone rocket',
					xp: 3,
					rules: {
						pass: [
							'Cone must have a circular shaped base'
						],
						options: [
							'The cone may have a truncated top (e.g. a paper cup)',
							'The cone may be polystyrene, cardboard, or 3D printed',
							'The cone may be either prefabricated or hand-made',
							'The motor may be permanently attached to the cone or in a mounting tube'
						],
						fail: [
							'The motor is ejected from the cone, posing a fire hazard and danger to spectators',
							'The vehicle causes a fire or fire hazard by being built in such a way that it burns/smolders'
						]
					},
					help: [
						'Polystyrene cones can be hard to come by these days, if using cardboard be conscious of fire hazards. Do not fly over dry crops or grass.',
						'blog:cone'
					]
				},
				'whirly': {
					name: 'Whirly-bird',
					desc: 'Build and fly a spinning rocket',
					disambiguation: 'This is not to be confused with a spin-stabilised "traditionally shaped" rocket, but is typically a flat, aerofoiled disc which rapidly spins as it moves through the air',
					xp: 20,
					rules: {
						pass: [
						],
						options: [
							'May be a kit, prefabricated or 3D printed'
						],
						fail: [
							'Vehicle does not fly reasonably "straight up"'
						]
					}
				},
				'pyramid': {
					name: 'Pyramid',
					desc: 'Build and fly a pyramid rocket',
					xp: 5,
					rules: {
						pass: [
							'The rocket must be a pyramid with a polygon-shaped base',
						],
						options: [
							'Pyramid may have 3, 4, 5 or 6 faces',
							'May separate on ejection'
						],
						fail: [
							'The rocket is prefabricated or 3d-printed in a single piece'
						]
					},
					help: [
						'blog:pyramid'
					]
				},
				'scratch': {
					name: 'Scratch Build',
					desc: 'Design, build and fly a rocket from scratch',
					xp: 10,
					rules: {
						pass: [
							'Must be designed, built and flown by you',
							'Simulations are encouraged, and are required at the RSO\'s discretion depending on the predictability of the rocket\'s design'
						],
						options: [
							'The rocket may be of any design, imitating a real or fictional rocket or be self-created'
						],
						fail: [
							'The rocket is made from a kit and not designed/made by the flyer'
						]
					},
					help: [
						'https://www.youtube.com/embed/x2fTdN1RijQ?si=SUZEJx8F5YAA8YUy',
						'https://www.youtube.com/embed/BnPSPdRbKRw?si=ZYymggLY4TwD0Hop',
						'https://www.youtube.com/embed/lib90QZ8lG8?si=oIHCe-hNnz3vFIQf',
						'https://www.youtube.com/embed/TBk8CBJf2K0?si=XHeGseZ3Ij7hm33a',
						'https://www.youtube.com/embed/kXs2w24Tkds?si=eqp34Fyo81WI3sAw',
						'https://www.youtube.com/embed/PlRaCN1xiwg?si=1-CzbCInMnN22PzD'
					]
				},
				'2stagebp': {
					name: 'Two Stager (BP)',
					desc: 'Build and fly a 2-stage rocket on BP motors',
					xp: 10,
					rules: {
						pass: [
							'The booster stage must must have structural components and not consist of just a motor',
							'Must be in-line staging, with both motors along the same vertical axis',
							'The second stage must ignite properly as intended',
							'All motors must be black-powder',
							'Both stages must be recovered (examiners discretion may be used for exceptional circumstances - simply not-finding the booster is not permitted)'
						],
						options: [
							'Any hot-gas staging mechanism may be used except CHAD'
						],
						fail: [
							'CHeap And Dirty staging is used (directly taping a booster to the back of an otherwise single-stage rocket)'
						]
					},
					help: [
						'https://www.youtube.com/embed/yLQ5CayOW2Q?si=Q_4nrYFziT6BckrC',
						'https://www.youtube.com/embed/H89Msbs7-JA?si=_szT1mCi0XZGMLjv',
						'https://www.youtube.com/embed/rIkH8rgO2xs?si=87ITbVo5XFQtnjc5'
					]
				},
				'3stagebp': {
					name: 'Three Stager (BP)',
					desc: 'Build and fly a 3-stage rocket on BP motors',
					xp: 15,
					rules: {
						pass: [
							'The booster stages must must have structural components and not consist of just a motor',
							'Must be in-line staging, with both motors axially in-line with the sustainer',
							'The second and third stages must ignite properly as intended',
							'All motors must be black-powder',
							'All stages must be recovered (examiners discretion may be used for exceptional circumstances - simply not-finding the booster is not permitted)'
						],
						options: [
							'Any hot-gas staging mechanism may be used except CHAD'
						],
						fail: [
							'CHeap And Dirty staging is used (directly taping a booster to the back of an otherwise single-stage rocket)'
						]
					},
					help: [
						'https://www.youtube.com/embed/yLQ5CayOW2Q?si=Q_4nrYFziT6BckrC',
						'https://www.youtube.com/embed/H89Msbs7-JA?si=_szT1mCi0XZGMLjv',
						'https://www.youtube.com/embed/rIkH8rgO2xs?si=87ITbVo5XFQtnjc5'
					]
				},
				'clusterbp': {
					name: 'Cluster (BP)',
					desc: 'Build and fly a rocket with a cluster of BP motors',
					xp: 10,
					rules: {
						pass: [
							'Cluster and ignition method must be inspected by the RSO prior to launch',
							'All motors must ignite properly',
							'The combined thrust from all motors must be within that allowed by your Certification level'
						],
						options: [
							'Use 2 or more BP motors',
							'Use any thrust class of motor, including a mix'
						],
						fail: [
							'One or more motors do not ignite',
							'Flight is unstable/unsafe'
						]
					},
					help: [
						'blog:clustering',
						'https://www.youtube.com/embed/BGuJnXVa3rg?si=_cUAQElLPlXePxcH',
						'https://www.youtube.com/embed/vTJ-CY7_7HU?si=GcfgbUcN9U_yHc5p'
					]
				},
				'scale': {
					name: 'Scale Scratch',
					desc: 'Design, build and fly a scale model of an existing rocket',
					xp: 15,
					rules: {
						pass: [
							'Must be a scale model of an existing rocket/missile',
							'Must be scaled, built and flown by you. The MAP Assessor may ask you what process you followed to produce the scale measurements',
							'Must be accurately scaled (exceptions made for static vs dynamic stability differences) as judged by eye against a comparison photo. In the case of disagreement another MAP Assessor or RSO may be consulted.'
						],
						options: [
							'Scale versions of ficticious rockets are permitted (e.g. from a cartoon or popular culture)',
						],
						fail: [
							'The rocket is made from a kit and not designed/made by the flyer',
							'Rocket is built from any metal parts',
							'Rocket is built from any material that could pose a danger to people or property',
							'The scaling is obviously not accurate',
							'The flyer cannot prove the existence of the rocket it is a scale model of'
						]
					},
					help: [
						'https://www.youtube.com/embed/x2fTdN1RijQ?si=SUZEJx8F5YAA8YUy',
						'https://www.youtube.com/embed/BnPSPdRbKRw?si=ZYymggLY4TwD0Hop'
					]
				},
				'upscale': {
					name: 'Upscale',
					desc: 'Design, build and fly an upscaled rocket',
					xp: 10,
					rules: {
						pass: [
							'Must be an upscale model of an existing rocket kit',
							'Must be scaled, built and flown by you. The MAP Assessor may ask you what process you followed to produce the scale measurements',
							'Must be at least 25% larger, by diameter or length as appropriate',
							'Must be scaled, built and flown by you. The MAP Assessor may ask you what process you followed to produce the scale measurements',
							'Must be accurately scaled (exceptions made for stability based differences) as judged by eye against a comparison photo. In the case of disagreement another MAP Assessor or RSO may be consulted.'
						],
						options: [
							'Choose any existing model rocket kit to upscale'
						],
						fail: [
							'Rocket is not an upscale of an existing rocket kit',
							'The rocket is a kit and not scratch built',
							'The scaling is obviously not accurate',
							'The flyer cannot prove the existence of the rocket it is a scale model of'
						]
					}
				},
				'downscale': {
					name: 'Downscale',
					desc: 'Design, build and fly a downscaled rocket',
					xp: 10,
					rules: {
						pass: [
							'Must be a downscale model of an existing rocket kit',
							'Must be scaled, built and flown by you. The MAP Assessor may ask you what process you followed to produce the scale measurements',
							'Must be at least 25% smaller, by diameter or length as appropriate',
							'Must be scaled, built and flown by you. The MAP Assessor may ask you what process you followed to produce the scale measurements',
							'Must be accurately scaled (exceptions made for stability based differences) as judged by eye against a comparison photo. In the case of disagreement another MAP Assessor or RSO may be consulted.'
						],
						options: [
							'Choose any existing model rocket kit to downscale'
						],
						fail: [
							'The rocket is not a downscale of an existing rocket kit',
							'The rocket is a kit and not scratch built',
							'The scaling is obviously not accurate',
							'The flyer cannot prove the existence of the rocket it is a scale model of'
						]
					}
				},
				'oddroc': {
					name: 'Oddroc',
					desc: 'Design, build and fly an unusual rocket',
					disambiguation: 'Do not confuse this with the Non-Standard Body task',
					xp: 25,
					rules: {
						pass: [
							'Must be a suitably unusual rocket design, e.g. a UFO, wonky ACME rocket, spool, TARDIS',
						],
						options: [
							'There are limitless designs for oddrocs, anything that is not a traditionally-shaped rocket - e.g. a UFO, a spool, a TARDIS, an X-Wing'
						],
						fail: [
							'Rocket does not fly stabily or safely - exceptions will be made for the odd-roc\'s expected flight profile, but it should not be wildly unstable'
						]
					}
				},
				'ring-fin': {
					name: 'Ring Fin',
					desc: 'Build and fly a rocket with a ring fin',
					disambiguation: 'Do not confuse this with the Tube Fins task',
					xp: 35,
					rules: {
						pass: [
							'Rocket must have a single ring fin and no other fins'
						],
						options: [
							'Ring may be cylindrical or polygonal'
						],
						fail: [
							'Ring fin becomes detached'
						]
					}
				},
				'tube-fins': {
					name: 'Tube Fins',
					desc: 'Build and fly a rocket with a tube fins',
					fullDesc: 'Build and fly a rocket which has tube fins',
					disambiguation: 'Do not confuse this with the Ring Fin task.',
					xp: 15,
					rules: {
						pass: [
							'Must feature multiple external tubes as fins',
						],
						options: [
							'May have "normal" fins in addition to tube fins'
						],
						fail: [
							'Tube fins are not aerodynamically significant'
						]
					}
				},
				'2stagecomp': {
					name: 'Two Stager (Composite)',
					desc: 'Build and fly a 2-stage rocket on composite motors',
					xp: 100,
					rules: {
						pass: [
							'Stages must separate cleanly and as intended',
							'Electronic ignition of the 2nd stage is required',
							'The second stage must ignite properly as intended',
							'Both stages must be recovered using active recovery methods',
							'"Composite" means any non-black-powder propellant'
						],
						options: [
							'You may use additional charges to separate the stages'
						],
						fail: [
							'Head-end ignition is used without Safety and Technical Comittee approval',
							'No part may recover using tumbling'
						]
					}
				},
				'boosters': {
					name: 'Detachable Boosters',
					desc: 'Build and fly a rocket with detachable boosters',
					xp: 100,
					rules: {
						pass: [
							'Boosters must detach from the rocket at an appropriate time during the flight',
							'Boosters must be outboard and not axially in-line with the main rocket body',
							'Boosters must include motors',
							'All motors must ignite as intended',
							'Boosters must be recovered (examiners discretion may be used for exceptional circumstances - simply not-finding the boosters is not permitted)',
						],
						options: [
							'Boosters may be ignited in a staged configuration',
							'Boosters may use tumble recovery - subject to RSO approval',
							'Booster motors may just be for effect and not required for a safe flight, but they must ignite'
						],
						fail: [
							'All boosters do not detach as intended',
							'Any booster does not ignite as intended',
							'Boosters are axially in-line with the main rocket body, e.g. like a normal staged rocket'
						]
					}
				},
				'non-std': {
					name: 'Non-Standard Body',
					desc: 'Build and fly a rocket built with an unusual body tube',
					fullDesc: 'Make use of non-standard components to build a "normal" rocket',
					disambiguation: 'Do not confuse this with the Odd-Roc task - this is about building a "normal" rocket with non-standard components.',
					xp: 30,
					rules: {
						pass: [
							'Body tube must be made from a repurposed, pre-existing component that is not a purpose-made rocket body tube'
						],
						options: [
							'Use any "tubular" component, e.g. Pringles tube, Toblerone box, Smarties tube'
						],
						fail: [
							'3D printing does not count, body tube must be pre-existing and repurposed - 3D printing is allowed for other components, e.g. nose cone'
						]
					}
				},
				'pods': {
					name: 'Pods',
					desc: 'Build and fly a rocket build outboard motor pods',
					xp: 50,
					rules: {
						pass: [
							'Pods must house motors',
							'All motors must ignite properly'
						],
						options: [
							'A central motor may be used and is advised for stability and safety',
							'Pod motors may just be for effect, and not required for the successful flight of the rocket from a thrust perspective'
						],
						fail: [
							'Any motor does not ignite'
						]
					}
				},
				'legged-lander': {
					name: 'Legged-Lander',
					desc: 'Build and fly a rocket which deploys landing legs',
					xp: 65,
					rules: {
						pass: [
							'Legs must be substantial enoguh to be reasonably judged as legs, and not just feet on the bottom of the rocket/fins',
							'Legs must be deployed after apogee/ejection and not be always-out',
							'Rocket must land on its legs'
						],
						options: [
							'Legs may be mechanically, pyrotechnically or electronically deployed',
							'Rocket may topple over after landing, if only due to uneven ground or drag from the recovery device. The MAP Assessor must judge the design of the legs such that the rocket has a reasonable chance of landing upright under more ideal ground conditions'
						],
						fail: [
							'Legs do not deploy',
							'Legs are insufficiently designed to reasonably guarantee a landing onto them',
							'Rocket topples over on landing due to too-fast a descent, causing a "bounce"',
							'Rocket lands in crops/grass taller than the clearance between the ground the the bottom of the rocket, such that it is supported by the crops, regardless of rocket orientation'
						]
					}
				},
				'supersonic': {
					name: 'Supersonic',
					desc: 'Fly faster than Mach 1',
					xp: 50,
					rules: {
						pass: [
							"Data from a commercial, off-the-shelf logging altimeter must show a sustained speed greater than 343m/s for at least 0.5s",
							"Rocket must be suitably designed and built to withstand the forces at supersonic speeds"
						],
						options: [

						],
						fail: [
							"Flight data only contains a spike (e.g. errors caused by ejection charges/buffeting) or only a few samples faster than Mach 1"
						]
					}
				}
			}
		},
		'recovery': {
			name: 'Recovery',
			color: 'dark-purple',
			tasks: {
				'parachute': {
					name: 'Parachute',
					desc: 'Recover a rocket by parachute',
					fullDesc: 'Fly any rocket and recover it using a parachute.',
					rules: {
						pass: [
							'Parachute must appropriately sized',
							'Parachute must properly deploy and remain attached',
							'Parachute must be in reusable condition after flight',
							'Rocket must descend at a safe speed under the parachute'
						],
						options: [],
						fail: [
							'Shroud lines are broken',
							'Parachute is non-trivially damaged',
							'Parachute does not deploy properly'
						]
					},
					help: [
						'blog:parachutes',
						'https://www.apogeerockets.com/Advanced_Construction_videos/Rocketry_Video_469',
						'https://www.youtube.com/embed/ROp6lli57fM?si=4-OYdo0sSusSFl8X',
						'https://www.youtube.com/embed/haPqfV4kHTM?si=QKKk88QL2tEtqtqV',
						'https://www.youtube.com/embed/N5l_SST5t8M?si=sTeJnIa7jYk_N4mO',
						'https://www.youtube.com/embed/ux2VpTMN6pU?si=OWjqc2nnOocm05Uh'
					],
					xp: 2
				},
				'streamer': {
					name: 'Streamer',
					desc: 'Recover a rocket by streamer',
					rules: {
						pass: [
							'Streamer must properly deploy and remain attached',
							'Streamer must be in reusable condition after flight',
							'Rocket must descend at a safe speed under the streamer'
						],
						fail: [
							'Streamer is non-trivially damaged'
						]
					},
					xp: 1,
					help: [
						'https://www.youtube.com/embed/sOBgwdvj9GA?si=Qy_4zOz1N0Bfc-QQ',
						'https://www.youtube.com/embed/z6GlAVmzDD4?si=xoA_xfI7Fp4nYNG_'
					]
				},
				'tumble': {
					name: 'Tumble',
					desc: 'Recover a rocket by tumbling',
					fullDesc: 'Recover a rocket by safely tumbling it back down to earth, non-ballistically.',
					rules: {
						pass: [
							'Rocket must safely tumble',
						],
						options: [
							'The rocket may separate into two pieces, but both parts must be designed to safely tumble'
						],
						fail: [
							'Rocket descends ballistically',
							'Boosters, pods, gliders etc do not count - the whole rocket must tumble by design',
							'The rocket is traditionally-shaped with no recovery device except nose-separation - this is unsafe'
						]
					},
					xp: 1,
					help: [
						'Tumble recovery is a simple, low-cost recovery method for small rockets. It involves the rocket separating into two sections after reaching peak altitude, with the nose cone and main body tumbling back to Earth. This tumbling action creates drag and slows the descent, reducing impact force. It\'s ideal for lightweight rockets and minimizes complexity.',
						'High drag rockets like cones or pyramids, which cannot fly ballistically do not need to separate in two, they may safely tumble down in the same, one-piece configuration they launched in.',
						'https://www.printables.com/embed/417266'
					]
				},
				'glider': {
					name: 'Glider',
					desc: 'Recover using wings',
					xp: 10,
					fullDesc: 'Build and fly a rocket glider',
					disambiguation: 'Do not confuse this with the Detachable Glider task',
					rules: {
						pass: [
							'Flight must be stable on ascent and descent',
							'Vehicle must be powered by at least one motor for the ascent, and glide passively down',
							'Vehicle must glide safely and stabily down using wings',
							'Must be a single-piece rocket glider with no detachable parts (motor self-ejection permitted at RSOs discretion)'
						],
						options: [
							'May be scrach built, a kit, or based on an existing design',
							'Wings may be fixed or deploy in some way',
							'Wings may feature movable aerodynamic surfaces',
							'Movable wing features may be continuously mechanically controlled, such as with elastic.',
							'Movable wing features may only be controlled by electronics for one event (e.g. deploy wings once, change aileron position once).'
						],
						fail: [
							'Vehicle is remote or continuously electronically controlled',
							'Vehicle separates or disintegrates',
							'Glider is attached to a rocket and separates - must be a single vehicle',
							'Descent is not gentle and stable, or involves significant stalls'
						]
					}
				},
				'monocopter': {
					name: 'Monocopter',
					desc: 'Flutter down like a sycamore seed',
					xp: 10,
					fullDesc: 'Build and fly a spinning, single winged rocket',
					rules: {
						pass: [
							'Must be well balanced and fly stable',
							'Must feature a single "wing" positioned opposite the propulsion'
						],
						options: [
							'There are many designs of monocopter available to choose from',
							'May include lateral balance components'
						],
						fail: [
							'Vehicle spins unstable or not reasonably "straight up"'
						]
					},
					help: [
						'https://www.artapplewhite.com/free/'
					]
				},
				'heli': {
					name: 'Helicopter',
					desc: 'Use blades to spin back to earth',
					fullDesc: 'Build and launch a rocket which deploys blades which cause the vehicle to spin gently back down.',
					xp: 30,
					rules: {
						pass: [
							'Vehicle must launch with blades stowed',
							'Blades must be deployed at approx. apogee'
						],
						options: [
							'Use 3 or more blades',
							'There are multiple possible mechanisms to deploy the blades',
							'Blades may be fully aerofoiled or a simpler profile'
						],
						fail: [
							'Blades do not deploy',
							'Blades do not cause the vehicle to rotate and spin down to earth',
							'Vehicle does not descent at a safe speed'
						]
					}
				},
				'detachable-glider': {
					name: 'Detachable Glider',
					desc: 'Deploy a glider which flies down separately',
					fullDesc: 'Build and fly a booster-assisted glider which detaches and recovers separately',
					xp: 30,
					rules: {
						pass: [
							'Flight must be stable on ascent and descent',
							'Booster must be powered by at least one motor for the ascent',
							'Glider must be unpowered',
							'Vehicle must glide safely and stabily down using wings',
							'Booster and glider must separate at an appropriate part of the flight',
							'Booster must recover using a parachute or streamer'
						],
						options: [
							'May be scrach built, a kit, or based on an existing design',
							'Glider may be passively or actively detached from the booster',
							'Glider wings may be fixed or deploy in some way',
							'Glider wings may feature movable aerodynamic surfaces',
							'Movable glider wing features may be continuously mechanically controlled, such as with elastic.',
							'Movable glider wing features may only be controlled by electronics for one event (e.g. deploy wings once, change aileron position once).'
						],
						fail: [
							'Any part is remote or continuously electronically controlled',
							'Glider does not separate cleanly, at the right time',
							'Descent is not gentle and stable, or involves significant stalls'
						]
					}
				},
				'rc-glider': {
					name: 'R/C Glider',
					desc: 'Fly a remote-controlled glider',
					xp: 65,
					disambiguation: 'Do not confuse this with the Glider or Detachable Glider task',
					rules: {
						pass: [
							'Flight must be stable on ascent and descent',
							'Vehicle must be powered by at least one motor for the ascent, and fly down under remote-control',
							'Vehicle must fly safely and stabily down using wings',
							'If using a detachable booster, this must recover safely',
							'RC components must be legal under local laws',
						],
						options: [
							'Can be a rocket-glider or a booster with a detachable glider',
							'May be scrach built, a kit, or based on an existing design',
							'Wings may be fixed or deploy in some way'
						],
						fail: [
							'Vehicle is remote controlled whilst under thrust from the rocket',
							'Descent flight is not gentle and stable, or involves significant stalls or is not well controlled'
						]
					}
				},
				'dual-deploy': {
					name: 'Dual Deploy',
					desc: 'Build and fly a dual-deployment rocket',
					xp: 50,
					rules: {
						pass: [
							'Use electronics to deploy your drogue/main parachute',
							'You must use a commercially available, off-the-shelf dual deploy flight computer',
							'You must follow all local laws regarding the use of ejection charge chemicals',
							'You must perform an ejection ground tests for drogue and main separation as applicable - MAP Assessor must witness these as successful'
						],
						options: [
							'A drogue parachute is not required, but you must separate your rocket at apogee for a tumble descent until you deploy the main',
							'You may use motor ejection for the drogue event or electronics (or both, for backup)'
						],
						fail: [
							'Ground test does not cleanly and energetically cause separation/deployment - you may try again',
							'Drogue/separation does not occur or not at approx. apogee',
							'Main does not deploy or not at specified altitude'
						]
					},
					help: [
						'https://www.youtube.com/embed/KFbQ17y98hU?si=dTzXGb8poZGWUdEw',
						'https://www.youtube.com/embed/H_VUtFPGfzg?si=c4ETuMNrosX9MJOO',
						'https://www.youtube.com/embed/GG-MBDEgR0c?si=HQ6rHygi6qFWA99U',
						'https://www.youtube.com/embed/BWvuzFgpiBI?si=rQsZysYzwMlECVXh',
						'https://www.youtube.com/embed/lpPIlvnjizw?si=K16O_p9ZescD-Pho',
						'https://www.apogeerockets.com/Peak-of-Flight/Newsletter626'
					]
				},
				// This is deprecated for now
				'multiple-chutes': {
					name: 'Multiple Parachutes',
					desc: 'Recover a rocket using multiple parachutes',
					disambiguation: 'This does not mean dual-depoy, this means use two smaller parachutes instead of one larger',
					xp: 5,
					rules: {
						pass: [
							'Both parachutes must deploy properly and not tangle',
							'Must be a different rocket than you use for the Separate Parts task'
						]
					},
					visible: false
				},
				'duration': {
					name: 'Parachute Duration',
					desc: 'Stay aloft for at least 1 minute',
					fullDesc: 'Fly a rocket and recover it using a parachute, where the total flight time is at least 1 minute.',
					xp: 5,
					rules: {
						pass: [
							'Rocket must be flown on a B (total impulse) or less',
							'MAP Assessor must witnesses and verify the flight duration',
							'Rocket must land within 4 minutes'
						],
						options: [
							'You may use a parachute or streamer',
							'You may want to go really high, use a large parachute, or both'
						],
						fail: [
							'Rocket lands sooner than 1 min after launch',
							'Rocket lands later than 4 mins after launch',
							'Rocket has wings or aerodynamic control surfaces'
						]
					}
				},
				'two-parts': {
					name: 'Separate Parts',
					desc: 'Recover a rocket in multiple parts',
					xp: 5,
					rules: {
						pass: [
							'Parts must be separate and not attached together after ejection',
							'Each part must be recovered successfully by its own parachute or streamer, no part may tumble',
							//,'Must be a different rocket than you use for the Multiple Parachutes task'
						],
						options: [],
						fail: [
							'Booster sections or detachable boosters/gliders do not count'
						]
					}
				},
				'diy-nylon-chute': {
					name: 'DIY Nylon Parachute',
					desc: 'Build and fly a home-made ripstop nylon parachute',
					xp: 50,
					rules: {
						pass: [
							'The parachute must be made from ripstop nylon (or similar non-flammable) fabric',
							'The parachute must be made from multiple pieces sewn together',
							'All seams and edges are to be stitched/overlocked',
							'The parachute must have multiple shroud lines securely stiched to it',
							'The parachute must be at least 90cm/36" in diameter',
							'The parachute must be flown, deploy properly and recover the rocket safely',
							'The parachute must be substantially intact after landing - minor damage from the ejection charge is permitted'
						],
						options: [
							'The parachute may contain a spill hole',
							'The parachute may be circular or any regular 5+ pointed polygon shape, annular or cruciform',
						],
						fail: [
							'Shroud lines are broken or detached',
							'Parachute does not deploy properly, or gets tangled',
							'Parachute burns or poses a fire hazard',
							'The parachute is substantially damaged after flying - small burns from the ejection charge are permitted',
						]
					},
					help: [
						'blog:parachutes',
						'https://www.apogeerockets.com/Advanced_Construction_videos/Rocketry_Video_469',
						'https://www.youtube.com/embed/ROp6lli57fM?si=4-OYdo0sSusSFl8X',
						'https://www.youtube.com/embed/haPqfV4kHTM?si=QKKk88QL2tEtqtqV',
						'https://www.youtube.com/embed/N5l_SST5t8M?si=sTeJnIa7jYk_N4mO',
						'https://www.youtube.com/embed/ux2VpTMN6pU?si=OWjqc2nnOocm05Uh'
					],
				},
				'powered-landing': {
					name: 'Land under thrust',
					desc: 'Use a rocket motor to control descent and land',
					xp: 500,
					rules: {
						pass: [
							"Requires Safety and Technical Comittee oversight - contact UKRA",
							"Must use a rocket motor to control the descent and land safely",
							"Must abide by the additional Safety Code rules for Thrust Vector Controlled rocket",
							"Must have an appropriate failsafe mechanism should the rocket deviate from 'vertical' - see the Safety Code"
						],
						options: [
							'May use motor gimballing or other stabilisation techniques',
							'May use a parachute or other drag method for the initial portion of the descent'
						],
						fail: [
							'Rocket does not stay within 20 degrees of vertical for powered portion of the descent'
						]
					}
				},
				'mechanical-release': {
					name: 'Mechanical Release',
					desc: 'Release parachute using a mechancical method',
					rules: {
						pass: [
							'Parachute must be prevented from deploying using a mechanical restriction',
							'Parachute must be deployed at the right time using a release of said mechanical restriction'
						],
						options: [
							'May be a commercially available or home-made mecahnism',
							'Hot wire cutter may be used',
							'Mechanical catch release (e.g. Jolly Logic) may be used',
							'Other innovative mechanical methods may be used'
						],
						fail: [
							'Parachute does not deploy properly or in time',
							'Deployment mechanism fails (even if the parachute otherwise does deploy by chance)'
						]
					},
					xp: 20
				},
			}
		},
		'mission': {
			name: 'Mission',
			color: 'dark-blue',
			tasks: {
				'payload': {
					name: 'Non-fragile Payload',
					desc: 'Deploy a non-fragile payload at apogee',
					fullDesc: 'Launch a rocket and deploy a non-fragile payload which descends under its own recovery device',
					xp: 10,
					rules: {
						pass: [
							'The rocket must contain and completely enclose the payload.',
							'The payload is to be released from the rocket at apogee and descend safely',
							'Payloads must have their own recovery devices',
							'The payload must be easily removed from the rocket for inspection - MAP Assessor should perform an inspection'
						],
						options: [
							'May be one or multiple payloads',
							'Payload can be any safe, non-fagile item - for example, an action figure',
							'Rocket may be a kit or scratch built'
						],
						fail: [
							'Payload is unsafe or would pose a danger should its recovery mechanism malfunction',
							'Payload cannot be inspected by the MAP Assessor and RSO',
							'Payload breaks or is non-trivially damaged',
							'Payload does not recover safely',
							'Payload is lost (exceptional situations allowed, such as getting stuck in a tree)'
						]
					}
				},
				'altimeter': {
					name: 'Altimeter',
					desc: 'Fly an altimeter and log apogee',
					disambiguation: 'Do not confuse this task with the Dual-Deployment task, the altimeter must only be used for logging although it may be a dual-deploy capable device.',
					xp: 10,
					rules: {
						pass: [
							'The altimeter must be a commercially available, off-the-shelf device',
							'The flight log must be submitted to UKRA',
							'The alitmeter must remain attached to the rocket'
						],
						options: [
							'Use any commercially available altimeter',
							'Altimeter may be a dual-deploy capable device, but must be used passively just to log the flight',
							'Enclose the altimeter in an electronics payload bay, or attach it to your shock-cord or similar location'
						],
						fail: [
							'Altimeter does not record the apogee altitude',
							'Altimeter is home made',
							'Altimeter is lost or damaged'
						]
					}
				},
				'diy-altimeter': {
					name: 'DIY Altimeter',
					desc: 'Fly a home-made altimeter',
					disambiguation: 'Do not confuse this task with Dual-Deployment, the altimeter must only be used for logging although it may be a dual-deploy capable device',
					xp: 75,
					rules: {
						pass: [
							'The altimeter must be passive and not control any aspect of the flight',
							'The flight log must be submitted to UKRA',
							'Must be robustly built',
							'Must be inspected by the MAP Assessor to ensure it meets these criteria',
							'MAP Assessor will quiz you on your methodology to understand what process you followed and what you have learned'
						],
						options: [
							'May be built from any sensible electronic components',
							'May use any software packages or paradigms - ensure you respect all software licenses'
						],
						fail: [
							'Altimeter is built in a temporary way, such as on a prototype board or with dupont jumper cables',
							'Any component joints, wires, connections etc are not safely and robustly made',
							'Altimeter fails to operate properly',
							'Altimeter is not recovered in a resuable state without repair',
							'Batteries (especially LiPos) are not properly enclosed and/or protected from damage which may cause harm'
						]
					}
				},
				'camera': {
					name: 'Camera',
					desc: 'Fly with an onboard camera',
					xp: 15,
					rules: {
						pass: [
							'The camera must be shown to be on and working - The MAP Assessor does not need to view the recorded imagery but does need to see the camera is on'
						],
						options: [
							'The camera may take stills or record video',
							'The camera may be inside the rocket body viewing out of a hole in the airframe, or be in a fairing outside of the body viewing in any direction',
						],
						fail: [
							'Camera is temporarily attached to the outside of a rocket, or is attached to the shock cord or similar - Camera must be properly enclosed within an electronics bay or fairing',
							'Camera is lost or damaged',
							'Camera fairing is non-trivially damaged'
						]
					},
					help: [
						'https://www.youtube.com/embed/kJD7rB61NoE?si=n0nj09jRg8zwbBKb'
					]
				},
				'egg': {
					name: 'Fragile Payload',
					desc: 'Fly a raw egg and recover it in-tact',
					fullDesc: 'Fly a raw egg inside a rocket, and recover it unbroken.',
					xp: 30,
					rules: {
						pass: [
							'Egg must be at least the size of a standard hen\'s egg',
							'Egg must be unbroken on landing - and then proved to not be hard boiled, mess must be cleaned up'
						],
						options: [
							'Egg may be ejected from the rocket and recovered separately or remain inside the rocket in a payload bay',
						],
						fail: [
							'Egg is broken - including cracks'
						]
					}
				},
				'satellite': {
					name: 'Satellite',
					desc: 'Deploy and recover an electronic payload',
					fullDesk: 'Deploy and recover an electronic payload which transmits measured data back to the ground.',
					xp: 50,
					rules: {
						pass: [
							'Electronics must measure meaningful data and transmit it to a ground station',
							'Data should be transmitted at one sample per second',
							'Transmission frequency must be changeable',
							'Transmission frequency, power, duty-cycle etc. must all be UK legal',
							'Must be ejected from the rocket and recovered separately and safely',
						],
						options: [
							'You can measure anything (but not only GNSS location), we recommend air temperature and/or pressure',
							'You may use any legal transmission medium/protocol/service',
							'It may contain a tracker, but must not only be a tracker',
							'Electronics may be any size or weight'
						],
						fail: [
							'Electronics fail to perform intended function',
							'Received data is not logged for at least 80% of the flight',
							'Data transmission mechanism is not UK legal',
							'Satellite payload is not recovered'
						]
					}
				},
				'altitude': {
					name: 'Altitude Target',
					desc: 'Fly a rocket to apogee at a specific altitude',
					xp: 40,
					rules: {
						pass: [
							'Commercial, off-the-shelf altimeter must be used',
							'Target altitude must be declared to MAP Assessor before launch',
							'Rocket must come within +/- 10% of target altitude - altimeter result must be shown to MAP Assessor'
						],
						options: [
							'You may target any altitude - subject to a valid NOTAM, ATC permission and flying site rules'
						]
					}
				},
				'mhc': {
					name: 'Mile High Club',
					desc: 'Fly a rocket to at least 5280ft',
					xp: 40,
					rules: {
						pass: [
							'Commercial, off-the-shelf altimeter must be used',
							'Rocket must pas 1609m/5280ft AGL - altimeter result must be shown to MAP Assessor'
						],
						options: [
							'You may use any motor or rocket design'
						]
					}
				},
				'diy-flight-computer': {
					name: 'DIY Flight Computer',
					desc: 'Design, build and fly your own flight computer',
					xp: 100,
					rules: {
						pass: [
							"Requires Safety and Technical comittee oversight - contact UKRA"
						]
					}
				}
			}
		},
		'launch': {
			name: 'Launch Control',
			color: 'dark-green',
			tasks: {
				'piston': {
					name: 'Piston Launcher',
					desc: 'Use a piston for launching',
					fullDesc: 'Launch any rocket using a piston-launch mechanism',
					rules: {
						pass: [
							'Piston mechanism must function properly'
						],
						options: [
							'You do not need to prove a performance advantage from using the piston launcher'
						],
						fail: [
							'Piston mechanism fails to operate as designed'
						]
					},
					xp: 10,
					help: [
						'https://www.apogeerockets.com/education/downloads/Newsletter47.pdf'
					]
				},
				'tube': {
					name: 'Tube Launcher',
					desc: 'Launch a lug-less rocket from within a tube',
					fullDesc: 'Launch a lug-less rocket from within a tube, like a mortar',
					rules: {
						pass: [
							'Rocket must have no launch-lugs or rail guides and be guided by the tube',
							'RSO must inspect the launcher and deem it safe',
							'Tube must be open at both ends, except for a minimal breach mechanism to stop the rocket falling straight down',
							'Tube must be completely smooth inside without any features the rocket can snag on - winding spirals on cardboard tubes are permitted',
							'Tube must be angled within the safety code requirements'
						],
						options: [
							'Make the rocket\'s fins deploy upon exiting the tube for extra kudos',
							'Your club may have a tube launcher available, otherwise you will need to provide your own'
						],
						fail: [
							'Tube launcher is deemed unsafe by the RSO',
							'Rocket jams in the tube',
							'Rocket is not sized to be almost the same outer-diameter as the tube\'s inner-diameter - rocket must not be able to rattle around inside the tube',
							'Rocket does not exit the tube and fly stable and safe',
							'Tube launcher is non-trivially damaged by the launch'
						]
					},
					xp: 20
				},
				'tower': {
					name: 'Tower Launcher',
					desc: 'Launch a lug-less rocket from a guide tower',
					rules: {
						pass: [
							'Rocket must have no launch-lugs or rail guides and be guided by the tower',
							'Tower and rocket must be properly sized with respect to each other to provide proper support and guidance'
						],
						options: [
							'There are different options for tower construction, use any that makes sense for your rocket',
							'Tower does not have to be built by or belong to the flyer'
						],
						fail: [
							'Rocket is launched from a rod/rail',
							'Rocket uses a (detachable) cradle to guidance on a rod/rail',
							'Rocket jams in the tower or otherwise doesn\'t launch safely'
						]
					},
					xp: 20
				},
				'cradle': {
					name: 'Cradle Launcher',
					desc: 'Launch a lug-less rocket using a cradle',
					disambiguation: 'Do not confuse this with the Launch Tower task. This is about having a rail guide which is temporarilly attached to the rocket just for launch, and which self detaches after leaving the rail.',
					rules: {
						pass: [
							'Rocket must have no launch-lugs or rail guides',
							'Cradle/rail-guide should self-detach once the rocket has left the pad'
						],
						options: [
							'There are multiple ways of creating a cradle',
							'There are multiple ways of making a self-releasing mechanism'
						],
						fail: [
							'The cradle causes non-trivial damage to the rocket',
							'The cradle does not detach as intended',
							'The cradle is damaged and is not resuable without non-trivial repair'
						]
					},
					xp: 35
				},
				'controller': {
					name: 'Launch Controller',
					desc: 'Build your own launch controller',
					xp: 75,
					rules: {
						pass: [
							"Requires Safety and Technical comittee oversight - contact UKRA"
						]
					}
				}
			}
		}
	},
	levels: [
		{
			id: 'recruit',
			name: 'Recruit',
			xpRequired: 15,
			tasks: [
				'bonus.swing',
				'bonus.drag-race',
				'propulsion.A/4',
				'propulsion.A/2',
				'propulsion.A',
				'construction.rtf',
				'construction.assembly',
				'construction.cone',
				'construction.kit',
				'recovery.parachute',
				'recovery.streamer',
				'recovery.tumble'
			]
		},
		{
			id: 'cadet',
			name: 'Cadet',
			xpRequired: 55,
			tasks: [
				'bonus.diy-simple-chute',
				'bonus.diy-wadding',
				'bonus.papering',
				'bonus.sim',
				'propulsion.B',
				'propulsion.C',
				'construction.pyramid',
				'construction.scratch',
				'construction.2stagebp',
				'construction.clusterbp',
				'recovery.two-parts',
				'recovery.duration'
			]
		},
		{
			id: 'pilot',
			name: 'Pilot',
			xpRequired: 150,
			tasks: [
				'bonus.baffle',
				'bonus.record',
				'bonus.canard',
				'propulsion.D',
				'propulsion.E',
				'propulsion.clustercomp18',
				'construction.scale',
				'construction.upscale',
				'construction.downscale',
				'recovery.glider',
				'recovery.monocopter',
				'mission.payload',
				'mission.altimeter',
				'launch.piston'
			]
		},
		{
			id: 'flight-engineer',
			name: 'Flight Engineer',
			xpRequired: 335,
			tasks: [
				'bonus.aerotech',
				'bonus.cti',
				'bonus.3dprinting',
				'bonus.spin-stabilised',
				'propulsion.F',
				'propulsion.clustercomp24',
				'construction.oddroc',
				'construction.non-std',
				'construction.tube-fins',
				'recovery.heli',
				'recovery.detachable-glider',
				'mission.egg',
				'mission.camera',
				'launch.tube',
				'launch.tower',
			]
		},
		{
			id: 'mission-specialist',
			name: 'Mission Specialist',
			xpRequired: 705,
			tasks: [
				'bonus.piston-ejection',
				'bonus.fibreglass',
				'bonus.carbonfibre',
				'propulsion.G',
				'construction.ring-fin',
				'construction.pods',
				'construction.legged-lander',
				'recovery.rc-glider',
				'recovery.dual-deploy',
				'recovery.diy-nylon-chute',
				'mission.satellite',
				'mission.altitude',
				'launch.cradle'
			]
		},
		{
			id: 'commander',
			name: 'Commander',
			tasks: [
				'propulsion.micro-hybrid',
				'construction.boosters',
				'construction.2stagecomp',
				'mission.diy-flight-computer',
				'recovery.powered-landing',
				'launch.controller'
			]
		}
	],
	bonuses: {
		'construction.whirly': 2,
		'construction.3stagebp': 50,
		'recovery.mechanical-release': 150,
		'mission.mhc': 250,
		'construction.supersonic': 350,
		'mission.diy-altimeter': 450
	}
}

let rawExpanded = null;

function expand(input)
{
	let subjectsArray = Object.keys(input.subjects).map((subjectId, subjectIndex) => {

		let subject = input.subjects[subjectId];

		subject.index = subjectIndex;

		let tasks = Object.keys(subject.tasks).map(taskId => {
			let task = subject.tasks[taskId];
			task.id = subjectId + '.' + taskId;
			task.subjectId = subjectId;
			task.taskId = taskId;
			return task;
		})

		return {
			id: subjectId,
			name: subject.name,
			color: subject.color,
			tasks: tasks
		}
	});

	subjectsArray.forEach(subject => {
		subject.tasks.forEach(task => {
			task.subjectName = subject.name;
			task.bgColor = subject.color
		})
	})


	return {
		// placeholders
		badges: [],
		completedTasks :[],

		subjects: subjectsArray,
		levels: input.levels.map(level => ({
			id: level.id,
			name: level.name,
			xpRequired: level.xpRequired,
			subjects: subjectsArray.map(subject => {

				let levelSubjectTasks = level.tasks.map(t => {
					let path = t.split('.')

					if(path[0] != subject.id)
						return null;

					let task = subjectsArray.find(s => s.id == subject.id)?.tasks.find(t => t.taskId == path[1])
					if(task == null)
					{
						console.error(`Cant find ${t}`)
						return null;
					}
					
					return task;
				}).filter(t => t && t.visible !== false);

				return {
					id: subject.id,
					name: subject.name,
					bgColor: subject.color,
					tasks: levelSubjectTasks
				}
			})
		})),
		bonuses: Object.entries(input.bonuses).map(([id, requiredHydrazine]) => {
			let path = id.split('.')

			let task = subjectsArray.find(s => s.id == path[0])?.tasks.find(t => t.taskId == path[1])
			if(task == null)
			{
				console.error(`Cant find ${id}`)
				return null;
			}
			
			// technically we're polluting a global object here, but this isnt a bug unless a bonus task is also not a bonus task...
			task.requiredHydrazine = requiredHydrazine;
			task.unlocked = false

			return task;
		}).filter(t => t)	
	}
}

export function initMap()
{
	if(rawExpanded != null)
		return;

	rawExpanded = expand(raw);
}

export function getMap(user)
{
	initMap();

	let userData = expand(JSON.parse(JSON.stringify(raw)));

	if(user == null)
	{
		for(let t = 0; t < userData.bonuses.length; t++)
		{
			let task = userData.bonuses[t];
			task.bgColor = 'grey'
		}
		return userData;
	}
	
	let userLevel = user.map.level;
	let userCompletedTasks = [];
	let userBadges = [];

	let userRequiredXP = 0;

	let found = false;
	for(let l = 0; l < userData.levels.length; l++)
	{
		let level = userData.levels[l];

		for(let s = 0; s < level.subjects.length; s++)
		{
			let subject = level.subjects[s];

			for(let t = 0; t < subject.tasks.length; t++)
			{
				let task = subject.tasks[t];
				if(found)
				{
					// disable future tasks
					//task.bgColor = 'grey'
					task.mode = 'future'
				}
				else if(level.id != userLevel)
				{
					task.mode = 'previous'
				}
				else
				{
					task.mode = 'current'

					if(level.xpRequired)
						userRequiredXP = level.xpRequired;
				}

				task.complete = false;

				if(user.map.completedTasks.findIndex(ct => ct == task.id) > -1)
				{
					task.complete = true;

					userCompletedTasks.push({
						bgColor: subject.bgColor,
						id: task.id,
						taskId: task.taskId,
						name: task.name,
						xp: task.xp,
						hydrazine: task.hydrazine
					})

					//if(task.xp !== undefined)
						task.bgColor = 'light'
				}
				
				let badgeTask = user.map.badges.find(b => b.taskId == task.id)
				if(badgeTask)
				{
					userBadges.push({
						bgColor: 'purple',
						id: task.id,
						taskId: task.taskId,
						name : badgeTask.type == 'first' ? 'First person to complete ' + task.name : 'TODO'
					})
				}
			}
		}

		level.percentComplete = level.subjects.flatMap(s => s.tasks).filter(t => t.complete).length * 100 / level.subjects.flatMap(s => s.tasks).length



		if(level.id == userLevel)
			found = true;
		
	}
	userCompletedTasks.sort((a, b) => b.points - a.points)
	userData.completedTasks = userCompletedTasks;

	userData.xpRequired = userRequiredXP;

	for(let t = 0; t < userData.bonuses.length; t++)
	{
		let task = userData.bonuses[t];

		task.unlocked = user.map.hydrazine >= task.requiredHydrazine;
		task.bgColor = task.unlocked ? task.bgColor : 'grey'

		if(!userData.hydrazineRequired)
		{
			if(task.requiredHydrazine > user.map.hydrazine)
				userData.hydrazineRequired = task.requiredHydrazine
		}

		task.complete = false;

		if(user.map.completedTasks.findIndex(ct => ct == task.id) > -1)
		{
			// dont mark hydrazine tasks as complete, as theyre repeatable
			task.complete = task.subjectId != 'bonus';

			userCompletedTasks.push({
				bgColor: task.bgColor,
				id: task.id,
				taskId: task.taskId,
				name: task.name,
				xp: task.xp,
				hydrazine: task.hydrazine
			})

			if(task.xp !== undefined)
				task.bgColor = 'light'
		}

		let badgeTask = user.map.badges.find(b => b.taskId == task.id)
		if(badgeTask)
		{
			userBadges.push({
				bgColor: 'purple',
				id: task.id,
				taskId: task.taskId,
				name : badgeTask.type == 'first' ? 'First person to complete ' + task.name : 'TODO'
			})
		}
	}

	// for people who have completed everything
	if(!userData.hydrazineRequired)
		userData.hydrazineRequired = user.map.hydrazine

	// for people who have completed everything
	if(!userData.xpRequired)
		userData.xpRequired = user.map.xp

	// TODO: non-task badges

	userData.badges = userBadges;
	return userData;
}

export function applyMapTasks(user, tasks, scoreboard)
{
	let validTasks = [];
	let badges = [];

	// TODO: why does this use raw and not userMap?

	for(let l = 0; l < raw.levels.length; l++)
	{
		let level = raw.levels[l];

		for(let t = 0; t < level.tasks.length; t++)
		{
			let task = level.tasks[t];

			if(tasks.find(t => t == task))
			{
				// allowed task (prev or current level)

				let parts = task.split('.');
				let fullTask = raw.subjects[parts[0]].tasks[parts[1]]

				if(user.map.completedTasks.find(ct => ct == task) && parts[0] != 'bonus')
				{
					// already completed
				}
				else
				{
					let xp = fullTask.xp || 0;

					// new task
					validTasks.push({
						id: task,
						xp: xp,
						hydrazine: fullTask.hydrazine || 0
					})
				}
			}
		}

		if(level.id == user.map.level)
			break;
	}
	
	let bonuses = Object.keys(raw.bonuses)
	for(let b = 0; b < bonuses.length; b++)
	{
		let bonus = bonuses[b];

		if(tasks.find(t => t == bonus))
		{
			let parts = bonus.split('.');
			let fullTask = raw.subjects[parts[0]].tasks[parts[1]]

			if(user.map.completedTasks.find(ct => ct == bonus) && parts[0] != 'bonus')
			{
				// already completed
			}
			else
			{
				// new task
				validTasks.push({
					id: bonus,
					xp: fullTask.xp || 0,
					hydrazine: fullTask.hydrazine || 0
				})
			}
		}
	}

	// badges
	let firstTasks = validTasks.filter(t => !scoreboard.isTaskCompleted(t.id)).map(t => ({
		type: 'first',
		taskId: t.id
	}))
	badges = badges.concat(firstTasks);

	let taskXP = validTasks.reduce((p, c) => p + c.xp, 0);
	let taskHydrazine = validTasks.reduce((p, c) => p + c.hydrazine, 0);

	return {
		tasks: validTasks.map(t => t.id),
		xp: taskXP,
		hydrazine: taskHydrazine,
		badges
	}
}

export function getLevelForXP(xp)
{
	let newLevel = 'recruit';

	for(let l = raw.levels.length - 1; l >= 0; l--)
	{
		if(xp >= raw.levels[l].xpRequired)
		{
			newLevel = raw.levels[l + 1].id
			break;
		}
	}

	return newLevel;
}

export function getBonusTasksForHydrazine(hydrazine)
{
	initMap();

	return rawExpanded.bonuses.filter(t => t.requiredHydrazine <= hydrazine);
}

export function getLevelName(id)
{
	initMap();

	return raw.levels.find(l => l.id == id)?.name || id
}